module.exports = {
  GENDER_FEMALE: 'components.passengerInfo.gender.values.feminino',
  GENDER_MALE: 'components.passengerInfo.gender.values.masculino'
};



// WEBPACK FOOTER //
// ./src/const/PassengersInfo.js